<template>
  <main class="w-100">
    <LoadingSpinner v-if="!completeLoading" />
    <div v-else class="d-flex justify-content-center m-2">
      <div class="col-md-12 card p-2">
        <table class="table table-striped" :key="domainhttpsindex">
          <thead class="thead-dark">
            <td></td>
            <td></td>
            <td>
              <strong>Domain</strong>
            </td>
            <td>
              <strong>Client</strong>
            </td>
            <td>
              <strong>Client Status</strong>
            </td>
            <td>
              <strong>Sales</strong>
            </td>
            <td>
              <strong>Sales status</strong>
            </td>
            <td>
              <strong>Workspace</strong>
            </td>
            <!-- <td v-if="condition === 'all_inactive'">
              <strong>Https</strong>
            </td> -->
            <td v-if="condition === 'all_inactive'">
              <strong>SPF</strong>
            </td>
            <td v-if="condition === 'all_inactive'">
              <strong>DKIM</strong>
            </td>
            <td v-if="condition === 'all_inactive'">
              <strong>DMARC</strong>
            </td>
            <td v-if="condition === 'all'">
              <strong>Https</strong>
            </td>
          </thead>
          <tbody>
            <tr v-for="(row, index) in list" :key="index">
              <td>
                {{ index + 1 }}
              </td>
              <td>
                <span
                  v-if="row.task_open_hours !== null"
                  class="badge"
                  :class="taskOpenHoursClass(row.task_open_hours)"
                >
                  {{ row.task_open_hours }} h
                </span>
              </td>
              <td>{{ row.domain }}</td>
              <td>
                <a
                  :href="'/clients/' + row.client_id"
                  class="text-primary"
                  target="_blank"
                  >{{ row.company_name }}</a
                >
              </td>
              <td>{{ row.client_status }}</td>
              <td>{{ row.sale_name }}</td>
              <td>{{ capitalizeFirstLetter(row.sale_status) }}</td>
              <td>{{ row.workspace }}</td>
              <!-- <td v-if="condition === 'all_inactive'">
                <i
                  v-if="row.https === '1'"
                  class="d-inline ml-2 cursor-pointer icon-checkmark text-success"
                ></i>
                <i
                  v-else
                  class="d-inline ml-2 cursor-pointer icon-close text-danger"
                ></i>
              </td> -->
              <!-- SPF -->
              <td v-if="condition === 'all_inactive'">
                <i
                  class="icon-circle"
                  :class="row.spf ? 'text-success' : 'text-danger'"
                ></i>
              </td>
              <!-- DKIM -->
              <td v-if="condition === 'all_inactive'">
                <i
                  class="icon-circle"
                  :class="row.dkim ? 'text-success' : 'text-danger'"
                ></i>
              </td>

              <!-- DMARC -->
              <td v-if="condition === 'all_inactive'">
                <i
                  class="icon-circle"
                  :class="row.dmarc ? ' text-success' : ' text-danger'"
                ></i>
              </td>
              <td v-if="condition === 'all'">
                <span
                  v-if="domainhttps[row.domain] == 'pending'"
                  class="loadingres mr-2 ml-2 spinner-border loading-spinner"
                ></span>
                <span
                  v-if="domainhttps[row.domain] == 'ok'"
                  class="icon-check text-success"
                ></span>
                <span
                  v-if="domainhttps[row.domain] == 'no'"
                  class="icon-close text-danger"
                ></span>
                <small
                  v-if="domaindns[row.domain] && domaindns[row.domain][0]"
                  class="ml-2"
                  >ip: {{ domaindns[row.domain][0]["ip"] }}</small
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </main>
</template>

<script>
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { workspaceService } from "@/_services";

export default {
  name: "DomainList",
  components: {
    LoadingSpinner,
  },
  props: {
    condition: {
      type: String,
      default: "all",
    },
  },
  computed: {
    capitalizeFirstLetter() {
      return (word) => {
        return word.charAt(0).toUpperCase() + word.slice(1);
      };
    },
  },
  data() {
    return {
      completeLoading: false,
      list: [],
      domainhttps: [],
      domaindns: [],
      domainhttpsindex: 32322332,
    };
  },

  created() {
    this.getCalendarDomains();
  },
  methods: {
    getCalendarDomains() {
      this.completeLoading = false;
      workspaceService
        .getWorkspaceDomains("", this.condition)
        .then((result) => {
          if (this.condition === "all") {
            result.forEach((r) => {
              this.domainhttps[r.domain] = "pending";
              workspaceService.getHttps(r.domain).then((result) => {
                this.domainhttps[r.domain] = result.https;
                this.domaindns[r.domain] = result.dns;
                this.domainhttpsindex++;
              });
            });
          }
          this.list = result;
          this.completeLoading = true;
        });
    },
    taskOpenHoursClass(task_open_hours) {
      if (task_open_hours < 12) {
        return "badge-warning";
      }
      return "badge-danger";
    },
  },
};
</script>
